"use client"

import { TableSortLabel } from "@mui/material"
import { ArrowDownwardIcon, ExpandAllIcon } from "@tc/ui-dfe/icons"
import { useEffect, useState } from "react"
import { SortOrder, Asc, Desc } from "../Button"

export interface SortableHeaderCellContentProps {
  id: string
  label: string
  sortBy: string
  order: SortOrder | undefined
  onSort: (colId: string) => void
}

export const SortableHeaderCellContent = ({
  id,
  label,
  sortBy,
  order,
  onSort,
}: SortableHeaderCellContentProps) => (
  <TableSortLabel
    data-testid="test-sortLabelRequests"
    active
    direction={sortBy === id ? order : "desc"}
    onClick={() => onSort(id)}
    IconComponent={!order ? ExpandAllIcon : ArrowDownwardIcon}
  >
    {label}
  </TableSortLabel>
)

export interface SortableHeaderProps {
  title: string
  defaultDirection?: SortOrder
  sortAttribute: string
  resetAttribute: string
  onSort: (attribute: string, direction: SortOrder) => void
}

export const SortableHeader = ({
  title,
  defaultDirection,
  onSort,
  sortAttribute,
  resetAttribute,
}: SortableHeaderProps) => {
  const [direction, setDirection] = useState<SortOrder | undefined>(
    defaultDirection,
  )

  useEffect(() => {
    if (resetAttribute !== sortAttribute) {
      setDirection(defaultDirection)
    }
  }, [resetAttribute, sortAttribute, setDirection, defaultDirection])

  const sortColumn = () => {
    const target = direction !== Asc ? Asc : Desc

    onSort(sortAttribute, target)
    setDirection(target)
  }

  return (
    <TableSortLabel
      data-testid="test-sortLabelRequests"
      active
      direction={direction}
      onClick={sortColumn}
      IconComponent={!direction ? ExpandAllIcon : ArrowDownwardIcon}
    >
      {title}
    </TableSortLabel>
  )
}
